var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChartSelection = function SvgChartSelection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.6665,
    y: 15.833,
    width: 1.66667,
    height: 1.66667,
    fill: "#546B7E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6665,
    y: 12.5,
    width: 1.66667,
    height: 1.66667,
    fill: "#546B7E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6665,
    y: 9.16699,
    width: 1.66667,
    height: 1.66667,
    fill: "#546B7E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6665,
    y: 5.83301,
    width: 1.66667,
    height: 1.66667,
    fill: "#546B7E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6665,
    y: 2.5,
    width: 1.66667,
    height: 1.66667,
    fill: "#546B7E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 15.833,
    width: 1.66667,
    height: 1.66667,
    fill: "#546B7E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 12.5,
    width: 1.66667,
    height: 1.66667,
    fill: "#546B7E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 9.16699,
    width: 1.66667,
    height: 1.66667,
    fill: "#546B7E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 5.83301,
    width: 1.66667,
    height: 1.66667,
    fill: "#546B7E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 2.5,
    width: 1.66667,
    height: 1.66667,
    fill: "#546B7E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.976 12.8185C4.69185 13.2921 4.84542 13.9064 5.319 14.1905C5.79258 14.4746 6.40684 14.3211 6.69099 13.8475L4.976 12.8185ZM8.3335 9.16634L8.8882 8.33429C8.66065 8.1826 8.38092 8.13071 8.11411 8.1907C7.8473 8.2507 7.6167 8.41735 7.476 8.65185L8.3335 9.16634ZM10.8335 10.833L10.2788 11.6651C10.7383 11.9714 11.3592 11.8472 11.6655 11.3877L10.8335 10.833ZM14.9989 6.38771C15.3052 5.92818 15.1811 5.30731 14.7215 5.00096C14.262 4.69461 13.6411 4.81878 13.3348 5.27831L14.9989 6.38771ZM6.69099 13.8475L9.19099 9.68084L7.476 8.65185L4.976 12.8185L6.69099 13.8475ZM7.7788 9.99839L10.2788 11.6651L11.3882 10.001L8.8882 8.33429L7.7788 9.99839ZM11.6655 11.3877L14.9989 6.38771L13.3348 5.27831L10.0014 10.2783L11.6655 11.3877Z",
    fill: "#546B7E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartSelection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart-selection.08429f82.svg";
export { ForwardRef as ReactComponent };